import type { ExternalLink } from '@backmarket/http-api/src/api-models/LinkExternal'

export type BundledMobilePlanActionType = 'redirect_to_partner_portal'

export const ORDERLINE_BUNDLED_MOBILE_PLAN_ACTIONS: Record<
  string,
  BundledMobilePlanActionType
> = {
  redirectToPartnerPortal: 'redirect_to_partner_portal',
}

export type OrderlineBundledMobilePlanStateLabelClass =
  | 'DEFAULT'
  | 'SUCCESS'
  | 'DANGER'
  | 'WARNING'

export type OrderlineBundledMobilePlanState = {
  enumState:
    | 'AWAITING_PAYMENT'
    | 'SUBSCRIBED'
    | 'NOT_ELIGIBLE'
    | 'AWAITING_CANCELATION'
    | 'CANCELED'
    | 'UNKNOWN'
  date: string | null
  label: string | null
  labelClass: OrderlineBundledMobilePlanStateLabelClass | null
}

export type OrderlineBundledMobilePlanPartnerProvider =
  | 'BOUYGUES_TELECOM'
  | 'FREENET'

export type OrderlineBundledMobilePlan = {
  state: OrderlineBundledMobilePlanState
  mobilePlanOfferLabel: string
  subscriptionId: string
  partnerPortalUrl: string | null
  partnerProvider: OrderlineBundledMobilePlanPartnerProvider
  partnerProviderLabel: string
  contractCommitmentLabel: string
  priceLabel: string | null
  priceSubLabel: string | null
  actions: {
    type: BundledMobilePlanActionType
    active: boolean
    label: string
    hint: string | null
    link: ExternalLink | null
    downloadable: boolean
  }[]
}
